
































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  List,
  Sticky,
  Popup,
  Toast,
  Swipe,
  SwipeItem,
  ImagePreview,
} from 'vant';
import { checkInfo, getuserInfo, getDetail, checkUser } from '../api';
import clounbtn from '../components/CloundbtnInfo.vue';
import XGplayer from '../components/XGplayer.vue';
import Poster from '../components/Canvas.vue';

Vue.use(List)
  .use(Sticky)
  .use(Popup)
  .use(Swipe)
  .use(ImagePreview)
  .use(SwipeItem);

@Component({
  components: {
    clounbtn,
    XGplayer,
    Poster,
  },
})
export default class Home extends Vue {
  data: any = {};
  headimg: any = '';
  btnimg: any = require('../assets/upload/uploadSuc/regardbtn.png');
  unionid: string | null = '';
  inway: any = '';
  rankinfo: any = {};
  info: any = {};
  user: any = {};
  voteName: string = '2023project/q2/2023byd_drbs';
  checkzp: any = {};
  cover: any = '';
  showshare: boolean = false;
  showSuccess: boolean = false;
  titleCoverList: any[] = [];
  videourl: string = '';
  async created() {
    this.inway = this.$route.query.inway;
    this.unionid = window.localStorage.getItem('unionid') + '';
    getDetail(this.unionid, this.inway).then((res: any) => {
      if (res.code === 200) {
        this.data = res.data;
        this.rankinfo = res.data;
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkInfo(this.unionid, this.inway).then((res: any) => {
      if (res.code === 200) {
        this.info = res.data;
        const cover = this.info.cover.split('|');
        this.cover = cover;
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkInfo(this.unionid, this.inway).then((res: any) => {
      if (res.code === 200) {
        this.info = res.data;
        this.titleCoverList = this.info.cover.split('|');
        const cover = this.info.cover.split('|');
        this.cover = cover.length > 0 ? cover[0] : '';
        const vidurl = this.info.videoStr.split('|');
        this.videourl = vidurl ? vidurl[0] : '';
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkUser(this.unionid).then((res: any) => {
      if (res.code === 200) {
        this.user = res.data;
        this.headimg = res.data.wxheadimg;
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
  }

  // tosharepage() {
  //   this.showshare = true;
  // }
  goback() {
    this.$router.push('index');
  }
  modifyThing() {
    this.$router.push('inupload?isexit=' + 1 + '&type=' + this.inway);
  }
  votSuccess() {
    this.showSuccess = !this.showSuccess;
    // window.location.reload();
  }
  // showshareClose() {
  //   this.showshare = false;
  // }
  showImage(data: any, index: number) {
    ImagePreview({
      images: data,
      startPosition: index,
    });
  }
}
